export const catalogItemsSortOrders = [
    'lotNumber',
    '-bidCount',
    '-currentBid',
    'currentBid',
    '-estimatedPrice',
    'estimatedPrice',
    '-hammerPrice',
    'promoted',
    '-publishDate',
    '-relevance',
] as const;
